import React from 'react';
import {Button, Modal} from 'antd';
import {ClientsAddForm} from '../clients/forms/add';
import {addCar, stateCar, userCarsState} from '../../../helpers/api';
import {Link} from 'react-router-dom';
import {handleRequestError} from '../../../helpers/errors';
import {inject, observer} from 'mobx-react/index';
import {UserCarsAddForm} from './forms/user-cars-add.form';


@inject("userCarsStore")
@observer
export class UserCarsAdd extends React.Component {
  state = {
    loading: false,
    exists: null,
    data: {},
    moving: false
  };

  render() {
    return (
      <Modal
        visible={true}
        onCancel={::this.onCancel}
        title="Добавление машины"
        footer={false}
        width={650}>
        <div className="clients-add">
          {this.state.exists && this.renderExists()}
          {!this.state.exists && <UserCarsAddForm loading={this.state.loading} submit={::this.submit} cancel={::this.onCancel} />}
        </div>
      </Modal>
    );
  }

  renderExists() {
    return (
      <div className="exist">
        {this.state.exists.dest === this.props.category ? this.renderExistsInCurrent() : this.renderExistsOptions() }
      </div>
    );
  }

  renderExistsInCurrent() {
    return (
      <div>
        <p style={{ marginBottom: 6 }}>Данное авто уже есть в вашем списке вкладке c ID={this.state.exists.cid}</p>

        <Button type={'primary'} onClick={::this.orderUp} style={{ marginRight: 12 }}>Переместить в начало</Button>
        <Button onClick={::this.onCancel}>Закрыть</Button>
      </div>
    );
  }


  onCancel() {
    this.props.history.goBack();
  }

  async submit(data) {
    console.log('submit data', data);
    this.setState({ loading: true });

    let res = await userCarsState(data.number);
    if(!res) {
      return false;
    }

    console.log('res', res);
    if(res.exists) {
      return this.setState({ exists: res, data })
    }

    res = await this.props.userCarsStore.addCar(data.number, data.note);
    this.setState({ loading: false });
    if (res) {
      this.props.history.goBack();
    }
  }

  orderUp() {
    this.props.history.goBack();
    setTimeout(() => {
      this.props.userCarsStore.orderUp([this.state.data.number])
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/user/user-cars-add.js